import React from "react";
import DoctrorsList from "./DoctrorsList";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { setSearch, setLocation, setDepartment, getSellersWithDigitalProducts } from "../../../Redux/publicseller-apis-for-bookings/slice";

const DoctorAppointment = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { search, location, department, selectedSegment, selectedSubsegment, pagination } = useSelector(
    (state: RootState) => state.segment
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setSearch(value));
    dispatch(
      getSellersWithDigitalProducts({
        search: value,
        location,
        department,
        segment: selectedSegment,
        subsegment: selectedSubsegment,
        page: 1,
        limit: pagination.limit,
      })
    );
  };

  const handleLocationSelect = (loc: string) => {
    dispatch(setLocation(loc));
    dispatch(
      getSellersWithDigitalProducts({
        search,
        location: loc,
        department,
        segment: selectedSegment,
        subsegment: selectedSubsegment,
        page: 1,
        limit: pagination.limit,
      })
    );
  };

  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setLocation(value));
    dispatch(
      getSellersWithDigitalProducts({
        search,
        location: value,
        department,
        segment: selectedSegment,
        subsegment: selectedSubsegment,
        page: 1,
        limit: pagination.limit,
      })
    );
  };

  const handleDepartmentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setDepartment(value));
    dispatch(
      getSellersWithDigitalProducts({
        search,
        location,
        department: value,
        segment: selectedSegment,
        subsegment: selectedSubsegment,
        page: 1,
        limit: pagination.limit,
      })
    );
  };

  const handleDepartmentSelect = (dept: string) => {
    dispatch(setDepartment(dept));
    dispatch(
      getSellersWithDigitalProducts({
        search,
        location,
        department: dept,
        segment: selectedSegment,
        subsegment: selectedSubsegment,
        page: 1,
        limit: pagination.limit,
      })
    );
  };
  return (
    <>
      <div className=" display-max">
        <div className=" card border border-radius-lg p-3">
          <div className=" d-flex gap-2 align-items-center">
            <div>
              <img
                src="../../assets/img/doc-1.png"
                className=" opacity-6"
                height={55}
                alt=""
              />
            </div>
            <div>
              <div className=" lh-sm">
                <b className=" text-black fs-4 fw-normal letter-spacing-1">
                  Find and select your preferance
                </b>
                <div>
                  <b className=" text-black fw-normal text-sm letter-spacing-1">
                    Search by preferred name
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-4 mb-4">
            <div className=" input-group input-group-outline">
              <input
                type="text"
                className="form-control fs-5"
                placeholder="Search by  name"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div>
            <b className=" text-black fw-bolder text-sm letter-spacing-1 ms-2">
              Not sure which to consult? Use the filters below
            </b>
          </div>
          <div className=" d-flex gap-3 mt-3 px-1 mb-3">
            <div className=" w-100">
              <div className=" input-group input-group-outline input-group-lg">
                <input
                  type="text"
                  className=" form-control fs-6"
                  placeholder="Choose Location"
                  value={location}
                  onChange={handleLocationChange}
                />
              </div>
            </div>
            <div className=" w-100">
              <div className=" input-group input-group-outline input-group-lg">
                <input
                  type="text"
                  className=" form-control fs-6"
                  placeholder="Choose Department"
                  value={department}
                  onChange={handleDepartmentChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className=" mt-2 mb-2">
          <b className=" text-black fs-4 ms-2 fw-normal letter-spacing-1">
            Select your preferance
          </b>
        </div>
        <DoctrorsList />
      </div>
      <div className=" display-mini display-mob">
        <div className=" card border border-radius-lg p-3 w-97 mx-auto mt-4 ">
          <div className=" d-flex justify-content-lg-start align-items-start gap-4">
            <div>
              <img
                src="../../assets/img/doc-1.png"
                className=" opacity-6"
                height={80}
                alt=""
              />
            </div>
            <div>
              <div className=" lh-sm">
                <b className=" text-black fs-5 fw-normal letter-spacing-1">
                  Find and select your preferance
                </b>
                <div>
                  <b className=" text-black fw-normal text-sm letter-spacing-1">
                    Search by preferred  name
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" mt-4 mb-4">
            <div className=" input-group input-group-outline">
              <input
                type="text"
                className="form-control fs-5"
                placeholder="Search by  name"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div>
            <b className=" text-black fw-bolder text-sm letter-spacing-1">
              Not sure which to consult? Use the filters below
            </b>
          </div>
          <div className="mt-3 px-1 mb-3">
            <div className=" w-100 mb-3">
              <div className=" input-group input-group-outline input-group-lg">
                <input
                  type="text"
                  className=" form-control fs-6"
                  placeholder="Choose Location"
                  value={location}
                  onChange={handleLocationChange}
                />
              </div>
            </div>
            <div className=" w-100">
              <div className=" input-group input-group-outline input-group-lg">
                <input
                  type="text"
                  className=" form-control fs-6"
                  placeholder="Choose Department"
                  value={department}
                  onChange={handleDepartmentChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className=" mt-2 mb-2 px-2">
          <b className=" text-black fs-4 ms-2 fw-normal letter-spacing-1">
            Select your preferance
          </b>
        </div>
        <DoctrorsList />
      </div>
    </>
  );
};

export default DoctorAppointment;
